import { render, staticRenderFns } from "./dataModalPart.vue?vue&type=template&id=5484151e&"
import script from "./dataModalPart.vue?vue&type=script&lang=js&"
export * from "./dataModalPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports